export default __webpack_public_path__ + "static/media/shutterstock_1396507904-min.766dbfd6.jpg";